import { Injectable } from '@angular/core';
import { BrowseRole } from '@app/domain/browse_role/model/browse-role.model';
import { BrowseRoleAPIService } from '@app/domain/browse_role/api/browse-role-api.service';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { Page } from '@app/models/api/page.model';
import { PagingParams } from '@app/models/api/paging-params.model';
import { SortingParams } from '@app/models/api/sorting-params.model';
import { BrowseRoleMessages } from '../locale/browse-role.messages';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

@Injectable({
  providedIn: 'root'
})
export class BrowseRolesBusinessService {

  // key -> the write currently in flight for that role. A duplicate call while one is in flight is
  // coalesced onto the same promise (see InFlightRegistry) rather than rejected.
  private updating: InFlightRegistry;
  uploadingFile: boolean;

  constructor(
    private browseRoleAPI: BrowseRoleAPIService,
    private notifyUtils: NotifyUtils
  ) {
    this.updating = new InFlightRegistry();
    this.uploadingFile = false;
  }

  get(
    ids: number[],
    name: string,
  ): Observable<BrowseRole[]> {
    return this.browseRoleAPI
      .get(ids, name);
  }

  getPaginated(
    pagingParams: PagingParams,
    sortingParams: SortingParams,
    ids: number[],
    name: string,
  ): Observable<Page<BrowseRole>> {
    return this.browseRoleAPI.getPaginated(pagingParams, sortingParams, ids, name);
  }

  getPinnedRoles(): Observable<BrowseRole[]> {
    return this.browseRoleAPI.getPinnedRoles();
  }

  markRoleAsPinned(roleId: number): Promise<BrowseRole[]> {
    return this.updating.run(roleId, () =>
      firstValueFrom(this.browseRoleAPI.markRoleAsPinned(roleId))
        .then(res => {
          this.notifyUtils.notify(BrowseRoleMessages.SUCCESS_PIN);
          return res;
        })
    );
  }

  unmarkRoleAsPinned(roleId: number): Promise<BrowseRole[]> {
    return this.updating.run(roleId, () =>
      firstValueFrom(this.browseRoleAPI.unmarkRoleAsPinned(roleId))
        .then(res => {
          this.notifyUtils.notify(BrowseRoleMessages.SUCCESS_UNPIN);
          return res;
        })
    );
  }
}
